import React, { useContext } from "react";
import { MenuSelection } from "../../../components/menuButtons/MenuSelection";
import { RefContext } from "../store/RefContext";
import { SaveImage } from "../../../components/SaveImage";
import { LocalStoreContext } from "../store/LocalStore";
import { StoreContext } from "../../../store/Store";
import { Loader } from "../../../components/loader/Loader";
// import { TitleItem } from "./TitleItem";

const defaultStrike = [
  "90.00%",
  "70.00%",
  "50.00%",
  "40.00%",
  "30.00%",
  "20.00%",
  "15.00%",
  "10.00%",
  "5.00%",
  "2.50%",
  "1.00%",
  "0",
  "-90.0%",
  "-70.0%",
  "-50.0%",
  "-40.0%",
  "-30.0%",
  "-20.0%",
  "-15.0%",
  "-10.0%",
  "-5.0%",
  "-2.5%",
  "-1.0%",
];

export const Controls = () => {
  const refs = useContext(RefContext);
  const [store] = useContext(StoreContext);
  const [lstore] = useContext(LocalStoreContext);
  const { fairvalue, loading } = lstore;
  const { defaultTicker } = store;
  return (
    <div
      style={{
        height: refs.componentSize.current["Controls"].height,
        width: refs.componentSize.current["Controls"].width - 17,
        margin: 0,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 0,
      }}
    >
      {/* <TitleItem data={fairvalue.rawdata} /> */}

      <div style={{ width: 30 }}></div>
      <SaveImage
        label="Download Table"
        prefix="fairvalue"
        selectkeys={["FairValue1", "FairValue2"]}
        svgRef={refs.fairValue}
      />
      <div style={{ width: 30 }}></div>
      <MenuSelection
        menukey="FairValueStrike"
        defaultSelection={defaultStrike}
        label="Strike%Chg"
        inputType="checkbox"
        data={fairvalue.rawdata}
        hide={true}
      />
      <div style={{ width: 30 }}></div>
      <MenuSelection
        menukey="FairValue1"
        defaultSelection={defaultTicker === "SPY" ? "AA" : defaultTicker}
        label="Ticker"
        inputType="radio"
        data={fairvalue.rawdata}
      />
      <div style={{ width: 30 }}>{loading && <Loader width={20} />}</div>
      <MenuSelection
        menukey="FairValue2"
        defaultSelection="SPY"
        label="Ticker"
        inputType="radio"
        data={fairvalue.rawdata}
      />
    </div>
  );
};
